// extracted by mini-css-extract-plugin
export default {"parentView":"style_parentView__-CMGQ","headerView":"style_headerView__W5DRk","contentsView":"style_contentsView__HMyeS","space1X":"style_space1X__WXtmN"};